module.exports = __webpack_public_path__ + "static/media/clemazon_g_location.6edbcd8d.png";